import { render, staticRenderFns } from "./navComponent.vue?vue&type=template&id=99b3387e&scoped=true"
import script from "./navComponent.vue?vue&type=script&lang=js"
export * from "./navComponent.vue?vue&type=script&lang=js"
import style0 from "./navComponent.vue?vue&type=style&index=0&id=99b3387e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b3387e",
  null
  
)

export default component.exports